export const simOnlyDataOptions = () => ({
    0: '0 MB',
    500: '500 MB',
    1000: '1 GB',
    2000: '2 GB',
    5000: '5 GB',
    10000: '10 GB',
    20000: '20 GB',
    25000: '25 GB',
    99999: 'Onbeperkt',
});

export const simOnlyMinutesOptions = () => ({
    0: '0 minuten',
    100: '100 minuten',
    200: '200 minuten',
    300: '300 minuten',
    400: '400 minuten',
    500: '500 minuten',
    99999: 'Onbeperkt',
});
